import { scrollBehavior } from '../scroll_behavior';

const header = document.querySelector('header');
const anchorSectionLinks = document.querySelectorAll(
  '#js-summary-side-bar ul a[href*="anchor"]',
);
const anchorFormSectionEl = document.querySelector(
  'a[href="#anchor-form-section"]',
);
const formSectionEl = document.querySelector(
  anchorFormSectionEl?.attributes.href.value,
);

const headerHeight = parseFloat(
  getComputedStyle(header, null).height.replace('px', ''),
);
const windowWidth = window.innerWidth;

// links section smooth scroll
for (const el of anchorSectionLinks) {
  el.addEventListener('click', e => {
    e.preventDefault();

    const refElement = document.querySelector(el.attributes.href.value);
    const y =
      refElement.getBoundingClientRect().top +
      window.pageYOffset -
      (headerHeight + (windowWidth >= 1024 ? 20 : 10));

    window.scrollTo({ top: y, behavior: scrollBehavior() });
  });
}

// form section smooth scroll
if (formSectionEl) {
  anchorFormSectionEl.addEventListener('click', e => {
    e.preventDefault();

    const formSectionYPosition =
      formSectionEl.getBoundingClientRect().top +
      window.pageYOffset -
      (headerHeight + (windowWidth >= 1024 ? 20 : 10));

    window.scrollTo({ top: formSectionYPosition, behavior: scrollBehavior() });
  });
}

if (windowWidth >= 1024) {
  window.onscroll = () => {
    const scrollPos = window.pageYOffset;

    for (const el of anchorSectionLinks) {
      const refElement = document.querySelector(el.attributes.href.value);
      const refElementPos = refElement.getBoundingClientRect().top + scrollPos;
      const refElementHeight = parseFloat(
        getComputedStyle(refElement, null).height.replace('px', ''),
      );
      const associatedProgressBar = el.querySelector('.js-anchor-progress-bar');
      const progressValue =
        ((scrollPos + headerHeight - refElementPos) / refElementHeight) * 100;

      if (refElementPos - headerHeight <= scrollPos + headerHeight) {
        el.classList.add('is-active');
        associatedProgressBar.style.width = `${progressValue}%`;
        progressValue >= 100
          ? el.classList.add('is-end')
          : el.classList.remove('is-end');
      } else {
        el.classList.remove('is-active', 'is-end');
        associatedProgressBar.style.width = '0%';
      }
    }
  };
}
